module.exports = __webpack_public_path__ + "img/2014-01_bloomberg_b.5d87b6ca.jpg";